<template>
    <div class="flex items-center justify-between w-full h-16 px-4 bg-vida-beige-2">
        <div>
            <img class="w-full" src="@/assets/images/logo/logo.webp" alt="logo">
        </div>
        <!-- <div>
            <i class="mr-4 cursor-pointer transition-300 far fa-heart fa-lg hover:text-red-500"></i>
            <i class="cursor-pointer transition-300 far fa-share-alt fa-lg hover:text-black"></i>
        </div> -->
    </div>
</template>

<script>
    export default {

    }
</script>

<style>

</style>